module.exports = __webpack_public_path__ + "img/fsecure_02.97bd6866.jpg";